import React from 'react'
import { observer } from 'mobx-react'
import usePortManager from '../hooks/use-port-manager'
import useSettingsManager from '../hooks/use-settings-manager'
import usePriceManager from '../hooks/use-price-manager'
import PropTypes from 'prop-types'
import { InputDefaultBase } from './InputDefaultBase'

function InputDefault ({size = 'full', type = 'text', min = null, max = null, updatesPrice = true, name, onChange, parent, value}) {
  const manager = usePortManager()
  const price_manager = usePriceManager()
  const settings_manager = useSettingsManager()

  const inputValue = typeof manager.getValue(name) === 'string' ? manager.getValue(name) : ''

  const _settings = name !== parent ? settings_manager.getInputOptionSettings(parent, name) : settings_manager.getInputOptionSettings(name, value)
  const input_settings = typeof _settings === 'object' ? _settings : { title: value }

  const title = typeof input_settings.title === 'string' ? input_settings.title : null
  const description = typeof input_settings.description === 'string' ? <p>{input_settings.description}</p> : null

  const _onchange = function (e) {
    let val = e.target.value
    manager.updateValue(name, val)

    if (updatesPrice) {
      price_manager.updatePrice()
    }
  }
  const onchange = typeof onChange === 'function' ? (e) => onChange(name, e.target.value) : _onchange

  return <InputDefaultBase
    size={size}
    name={name}
    value={inputValue}
    description={description}
    onChange={onchange}
    min={min}
    max={max}
    title={title}
    type={type}
  />
}

InputDefault.propTypes = {
  size: PropTypes.oneOf(['full', 'half']),
  type: PropTypes.string,
  name: PropTypes.string.isRequired,
}

export default observer(InputDefault)